import React, { useState } from 'react';
import './Formulario.css';

let headerImg = null;
let footerImg = null;
try { headerImg = require('../assets/images/pringles_top.png'); } catch {}
try { footerImg = require('../assets/images/pringles_bottom.png'); } catch {}

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const Formulario = ({ userData }) => {
  const getAuthData = () => {
    if (userData) return userData;
    try {
      const stored = sessionStorage.getItem('userAuthData');
      if (stored) {
        const parsed = JSON.parse(stored);
        sessionStorage.removeItem('userAuthData');
        return parsed;
      }
    } catch (e) {
      console.error('Error al leer userAuthData de sessionStorage:', e);
    }
    return null;
  };

  const authData = getAuthData();

  const [formData, setFormData] = useState({
    email: authData?.email || '',
    nombreApellido: authData?.nombreApellido || '',
    dni: '',
    telefono: '',
    numeroTicket: '',
    ticketFile: null,
    compressedImageBase64: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (submitStatus) {
      setSubmitStatus(null);
      setSubmitMessage('');
    }
  };

  const compressImage = (file, maxWidth = 1024, quality = 0.8) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL(file.type || 'image/jpeg', quality));
        };
        img.onerror = (error) => reject(error);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (submitStatus) {
      setSubmitStatus(null);
      setSubmitMessage('');
    }
    try {
      if (file.size > 100 * 1024) {
        const compressedBase64 = await compressImage(file);
        setFormData(prev => ({
          ...prev,
          ticketFile: new File([file], file.name, { type: file.type }),
          compressedImageBase64: compressedBase64
        }));
      } else {
        setFormData(prev => ({ ...prev, ticketFile: file, compressedImageBase64: null }));
      }
    } catch (error) {
      console.error('Error al comprimir imagen:', error);
      setFormData(prev => ({ ...prev, ticketFile: file, compressedImageBase64: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setSubmitMessage('');

    if (!formData.ticketFile) {
      setSubmitStatus('error');
      setSubmitMessage('Por favor, seleccioná una imagen del ticket antes de enviar el formulario.');
      setIsSubmitting(false);
      return;
    }

    try {
      const ticketImageBase64 = formData.compressedImageBase64
        ? formData.compressedImageBase64
        : await compressImage(formData.ticketFile);

      const payload = {
        email: formData.email.trim(),
        nombreApellido: formData.nombreApellido.trim(),
        dni: formData.dni.trim(),
        telefono: formData.telefono.trim(),
        numeroTicket: formData.numeroTicket.trim(),
        ticketImage: ticketImageBase64
      };

      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSubmitStatus('success');
        setSubmitMessage('¡Formulario enviado exitosamente!');
        setFormData({
          email: '',
          nombreApellido: '',
          dni: '',
          telefono: '',
          numeroTicket: '',
          ticketFile: null,
          compressedImageBase64: null
        });
        const fileInput = document.getElementById('ticketFile');
        if (fileInput) fileInput.value = '';
      } else {
        setSubmitStatus('error');
        if (response.status === 409) {
          setSubmitMessage(data.message || 'Este número de ticket ya fue registrado. Cada ticket solo puede usarse una vez.');
        } else {
          setSubmitMessage(data.message || data.error || 'Error al enviar el formulario. Por favor intentá nuevamente.');
        }
      }
    } catch (error) {
      console.error('Error al enviar formulario:', error);
      setSubmitStatus('error');
      setSubmitMessage('Error de conexión. Por favor verificá tu internet e intentá nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="formulario-container">

      {headerImg && <img src={headerImg} alt="Destapá el fútbol con Pringoools" className="formulario-top-img" />}

      {/* Form */}
      <div className="formulario-content">
        <form onSubmit={handleSubmit} className="formulario-form">

          <div className="form-field">
            <label className="form-label">NOMBRE Y APELLIDO</label>
            <input
              type="text"
              name="nombreApellido"
              value={formData.nombreApellido}
              onChange={handleInputChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-field">
            <label className="form-label">DNI</label>
            <input
              type="tel"
              name="dni"
              value={formData.dni}
              onChange={handleInputChange}
              className="form-input"
              inputMode="numeric"
              pattern="[0-9]*"
              required
            />
          </div>

          <div className="form-field">
            <label className="form-label">TELÉFONO{'\n'}DE CONTACTO</label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleInputChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-field">
            <label className="form-label">NÚMERO DE{'\n'}TICKET</label>
            <input
              type="text"
              name="numeroTicket"
              value={formData.numeroTicket}
              onChange={handleInputChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-field">
            <label className="form-label">CARGÁ TU TICKET</label>
            <div className="file-upload-container">
              <input
                type="file"
                id="ticketFile"
                name="ticketFile"
                onChange={handleFileChange}
                accept="image/*"
                className="file-input"
              />
              <label htmlFor="ticketFile" className="file-upload-button">
                ADJUNTÁ LA FOTO
              </label>
              {formData.ticketFile && (
                <span className="file-name">{formData.ticketFile.name}</span>
              )}
            </div>
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'ENVIANDO...' : 'ENVIÁ EL FORMULARIO'}
          </button>

          {submitStatus === 'success' && (
            <div className="submit-message submit-message-success">{submitMessage}</div>
          )}
          {submitStatus === 'error' && (
            <div className="submit-message submit-message-error">{submitMessage}</div>
          )}
        </form>
      </div>

      {footerImg && <img src={footerImg} alt="Pasos para participar" className="formulario-bottom-img" />}

    </div>
  );
};

export default Formulario;
